"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toDate = exports.toInt = exports.toDecimal = void 0;

exports.toDecimal = function (s) {
  var r = parseFloat(s);

  if (isNaN(r)) {
    return null;
  }

  return r;
};

exports.toInt = function (s) {
  try {
    return parseInt(s);
  } catch (err) {
    return null;
  }
};

exports.toDate = function (s) {
  try {
    return new Date(s);
  } catch (err) {
    return null;
  }
};